import { pushNotification } from '../../../core/functions/pushNotifications';
import i18next from 'i18next';
import { v4 as uuidv4 } from 'uuid';

export const confirmDeliveryReadyOnPoint = (payload, reducers, data) => {
  const uuid = uuidv4();
  const { placeId, pointId } = payload;
  const { notificationDispatch } = reducers;
  const date = new Date().getTime();
  const message = i18next.t('orders.NOTIFICATIONS.delivery_ready');
  const newNotification = new CustomEvent('Notification', {
    detail: { message, type: 'success', orderId: uuid, date: new Date().getTime() },
  });
  window.dispatchEvent(newNotification);
  notificationDispatch({
    type: 'UPDATE_NOTIFICATION',
    payload: {
      notificationId: uuid,
      message,
      placeId,
      pointId,
      type: 'success',
      date,
    },
  });

  pushNotification(message);
};
